import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// Goes to the previous screen; falls back to `to` when there is no in-app history (deep link).
export default function BackButton({ to = "/", forceTo = false, label = "Voltar" }) {
  const navigate = useNavigate();
  const go = () => {
    if (!forceTo && window.history.state?.idx > 0) navigate(-1);
    else navigate(to);
  };
  return (
    <button type="button" onClick={go} className="mb-3 inline-flex min-h-[48px] items-center gap-2 rounded-xl pr-3 text-lg font-semibold text-slate-700 hover:text-orange-600" data-testid="back-button">
      <ArrowLeft className="h-6 w-6" /> {label}
    </button>
  );
}
